export const Collections = () => {
  const items = [
    {
      name: "Oasis des lettres",
      logo: "/collections/oasis-des-lettres.jpg",
      tagline: "Littérature & création",
      description:
        "Notre collection littéraire dédiée aux voix singulières de la création contemporaine : romans, poésie, contes, témoignages. Une oasis pour les plumes qui osent.",
    },
    {
      name: "Pyramide des sciences",
      logo: "/collections/pyramide-des-sciences.jpg",
      tagline: "Recherche & savoirs",
      description:
        "Notre collection scientifique et académique : essais universitaires, études sociologiques, recherches en sciences humaines et patrimoniales. Le sommet du savoir.",
    },
  ];

  return (
    <section
      data-testid="collections-section"
      className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F4F1EA]"
    >
      <div className="flex items-center gap-3 mb-4">
        <span className="h-px w-8 bg-[#9E4735]" />
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body">
          Nos collections
        </p>
      </div>
      <h2 className="font-serif text-4xl md:text-5xl font-light text-[#1A1A1A] leading-tight mb-4 max-w-3xl">
        Deux <em className="text-[#2C402E]">univers</em>, une même exigence
      </h2>
      <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl mb-16">
        Nos ouvrages sont publiés sous deux collections complémentaires,
        couvrant la création littéraire et la pensée scientifique.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
        {items.map((c, i) => (
          <article
            key={c.name}
            data-testid={`collection-${c.name.toLowerCase().replace(/\s/g, "-")}`}
            className="bg-[#FAF9F6] border border-[#D1CFC7] p-10 md:p-12 hover:border-[#2C402E] transition-colors fade-in-up flex flex-col items-start"
            style={{ animationDelay: `${i * 120}ms` }}
          >
            <div className="bg-white border border-[#D1CFC7] p-4 mb-8 self-start">
              <img
                src={c.logo}
                alt={`Logo ${c.name}`}
                className="h-28 md:h-32 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <p className="text-[10px] tracking-[0.25em] uppercase text-[#9E4735] font-body mb-3">
              {c.tagline}
            </p>
            <h3 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] leading-tight mb-5">
              {c.name}
            </h3>
            <p className="text-base text-[#4A4A4A] font-body leading-relaxed">
              {c.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};
